export default () => ({
  BRIGHTCOVE_EVENTS: {
    PLAY_REQUEST: 'play_request',
    VIDEO_IMPRESSION: 'video_impression',
    VIDEO_VIEW: 'video_view',
    VIDEO_ENGAGEMENT: 'video_engagement'
  }
});
